import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { LOGIN_ADMIN } from "../../services/ApiCalls";

function* loginUserSaga({ payload, callBack }) {
  try {
    const response = yield call(LOGIN_ADMIN, payload);
    if (response.data.status == "success") {
      toast.success(response?.data?.message);
      localStorage.setItem("token", response?.data?.data?.token);
      localStorage.setItem("_id", response?.data?.data?._id);
      localStorage.setItem("profileImage", response?.data?.data?.profileImage);
      callBack && callBack();
      yield put(ACTION.loginAdmin_Success(response?.data?.data));
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.loginAdmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.loginAdmin_Fail(error));
  }
}

function* LoginSaga() {
  yield takeEvery(CONST.LOGIN_ADMIN, loginUserSaga);
}

export default LoginSaga;
